import {useTranslation} from 'react-i18next';

import {Chip, Divider, Grid, Skeleton, Typography} from '@mui/material';

import {useCompanySecuritySettings} from './hooks/useCompanySecuritySettings';
import {neutral, scorePill} from '../../../layouts/theme/designSystem';

const activeChipSx = {bgcolor: scorePill.high.bgcolor, color: scorePill.high.color, fontWeight: 600};
const inactiveChipSx = {bgcolor: neutral[100], color: neutral[700], fontWeight: 600};

export const TwoFactorAuthentication = () => {
  const {t} = useTranslation('translation', {keyPrefix: 'companySettings.twoFactorAuthentication'});
  const {twoFactor, isLoading, error} = useCompanySecuritySettings();

  const rows = [
    {
      id: 'enabled',
      label: t('enabledLabel'),
      value: twoFactor.enabled,
      status: t(twoFactor.enabled ? 'enabled' : 'disabled'),
    },
    {
      id: 'enforced',
      label: t('enforcedLabel'),
      value: twoFactor.enforced,
      status: t(twoFactor.enforced ? 'yes' : 'no'),
    },
  ];

  const showError = !isLoading && !!error;
  const showRows = !isLoading && !error;

  return (
    <>
      <Typography variant='h3'>{t('title')}</Typography>
      <Typography variant='body1' gutterBottom>
        {t('subtitle')}
      </Typography>
      <Divider
        sx={{
          width: '100%',
          marginBottom: '16px',
        }}
      />

      {isLoading && (
        <Grid container rowSpacing={1.5}>
          {rows.map((row) => (
            <Grid key={row.id} item xs={12}>
              <Skeleton variant='rounded' height={32} />
            </Grid>
          ))}
        </Grid>
      )}

      {showError && (
        <Typography variant='body2' color='error'>
          {t('loadError')}
        </Typography>
      )}

      {showRows && (
        <Grid container rowSpacing={1.5}>
          {rows.map((row) => (
            <Grid key={row.id} item container xs={12} justifyContent='space-between' alignItems='center'>
              <Typography variant='body2'>{row.label}</Typography>
              <Chip size='small' label={row.status} sx={row.value ? activeChipSx : inactiveChipSx} />
            </Grid>
          ))}

          {twoFactor.enforced && (
            <Grid item xs={12}>
              <Typography variant='body2' color='text.secondary'>
                {t('enforcedHint')}
              </Typography>
            </Grid>
          )}

          <Grid item xs={12}>
            <Typography variant='body2' color='text.secondary'>
              {t('contactHint')}
            </Typography>
          </Grid>
        </Grid>
      )}
    </>
  );
};
